<div class="card mb-2 wow detalle-cliente" [ngClass]="{'emp_recibidos__details--hidden': !visible}">
    <div class="card-body justify-content-between">
        <div class="row filtros-header" style="
        border-bottom: 1px solid #dee2e6;
        justify-content: space-between;
        align-items: center;
      ">
            <h4>
                Vista Intercambio SII
            </h4>
        </div>
    </div>
    <div class="card-body justify-content-between">
        <div class="table-responsive" *ngIf="listaDocumentos">
            <table class="table table-striped table-hover table-sm align-middle">
                <thead class="grey lighten-2">
                    <tr>
                        <th scope="col">Fecha</th>
                        <th scope="col">Folio</th>
                        <th scope="col">Rut</th>
                        <th scope="col">Detalle</th>
                        <th scope="col">Monto Neto</th>
                        <th scope="col">Monto Exento</th>
                        <th scope="col">Impto.Adic</th>
                        <th scope="col">Total Bruto</th>
                        <th scope="col">EdoSII</th>
                        <th scope="col">AR.</th>
                        <th scope="col">Rec.Merc.</th>
                        <th scope="col">Resp.com.</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngIf="loading">
                        <td colspan="100%" style="text-align: center">
                            <mdb-spinner spinnerColor="blue"></mdb-spinner>
                        </td>
                    </tr>
                    <tr *ngIf="!loading && listaDocumentos?.length === 0">
                        <td colspan="100%" style="text-align: center">
                            No se encontró información
                        </td>
                    </tr>
                    <tr *ngFor="let doc of listaDocumentos">
                        <td>{{doc.fecha | fecha}}</td>
                        <td>{{doc.folio | numerico}}</td>
                        <td>{{doc.rutFormato | rut}}</td>
                        <td>{{doc.razon_social}}</td>
                        <td>{{doc.monto_neto | numerico}}</td>
                        <td>{{doc.monto_exento | numerico}}</td>
                        <td>{{doc.impuesto_adicional | numerico}}</td>
                        <td>{{doc.total_bruto | numerico}}</td>
                        <td class="text-center">
                            <i *ngIf="doc.intento_envio_al_sii" class="fa fa-check-circle fa-lg green-text"></i>
                        </td>
                        <td class="text-center">
                            <ng-container *ngIf="doc.showAROptions">
                                <ng-container *ngIf="!doc.ARLoading">
                                    <i *ngIf="!doc.showAcSendButton && doc.acuse_recibo === true"
                                        class="fas fa-envelope fa-lg green-text"></i>
                                    <i *ngIf="!doc.showAcSendButton && doc.acuse_recibo === false"
                                        class="fas fa-envelope fa-lg red-text"></i>
                                    <button *ngIf="doc.showAcSendButton" mdbBtn type="button" size="sm" color="info"
                                        mdbWavesEffect (click)="reSend(doc)">
                                        Enviar
                                    </button>
                                </ng-container>
                                <mdb-spinner *ngIf="doc.ARLoading" spinnerColor="blue" spinnerType="small">
                                </mdb-spinner>
                            </ng-container>
                        </td>
                        <td>
                            <ng-container *ngIf="doc.showRecMercOptions">
                                <ng-container *ngIf="!doc.RecMercLoading">
                                    <mdb-badge *ngIf="!doc.showRecMercSendButton && doc.recepcion_mercaderia === true"
                                        pill="true" success="true">Aprobado
                                    </mdb-badge>
                                    <mdb-badge *ngIf="!doc.showRecMercSendButton && doc.recepcion_mercaderia === false"
                                        pill="true" danger="true">Rechazado
                                    </mdb-badge>
                                    <button *ngIf="doc.showRecMercSendButton" mdbBtn type="button" size="sm"
                                        color="info" mdbWavesEffect
                                        (click)="showModalObservaciones('RECEP_MERCADERIA', doc)">
                                        Enviar
                                    </button>
                                </ng-container>
                                <mdb-spinner *ngIf="doc.RecMercLoading" spinnerColor="blue" spinnerType="small">
                                </mdb-spinner>
                            </ng-container>
                        </td>
                        <td>
                            <ng-container *ngIf="doc.showRespComOptions">
                                <ng-container *ngIf="!doc.RespComLoading">
                                    <mdb-badge *ngIf="!doc.showRespComSendButton && doc.respuesta_comercial === true"
                                        pill="true" success="true">Aprobado
                                    </mdb-badge>
                                    <mdb-badge *ngIf="!doc.showRespComSendButton && doc.respuesta_comercial === false"
                                        pill="true" danger="true">Rechazado
                                    </mdb-badge>
                                    <button *ngIf="doc.showRespComSendButton" mdbBtn type="button" size="sm"
                                        color="info" mdbWavesEffect
                                        (click)="showModalObservaciones('RTA_COMERCIAL', doc)">
                                        Enviar
                                    </button>
                                </ng-container>
                                <mdb-spinner *ngIf="doc.RespComLoading" spinnerColor="blue" spinnerType="small">
                                </mdb-spinner>
                            </ng-container>
                        </td>
                    </tr>

                    <!-- <tr>
                        <td>12/04/2021</td>
                        <td>165</td>
                        <td>14682084-0</td>
                        <td>SERRANO 1.420</td>
                        <td>235.264</td>
                        <td>0</td>
                        <td>0</td>
                        <td>297.500</td>
                        <td class="text-center">
                            <i class="fa fa-check-circle fa-lg green-text"></i>
                        </td>
                        <td class="text-center"><i class="fas fa-envelope" fa-lg></i></td>
                        <td>
                            <mdb-badge pill="true" success="true">Aprobado</mdb-badge>
                        </td>
                        <td>
                            <mdb-badge pill="true" danger="true">Rechazado</mdb-badge>
                        </td>
                    </tr>
                    <tr>
                        <td>07/04/2021</td>
                        <td>1139</td>
                        <td>76150970-5</td>
                        <td>INTEGRACIÓN DE SISTEMAS Y SERVICIOS TECNOLOGI...</td>
                        <td>235.264</td>
                        <td>0</td>
                        <td>0</td>
                        <td>279.964</td>
                        <td class="text-center">
                            <i class="fa fa-check-circle fa-lg green-text"></i>
                        </td>
                        <td class="text-center">
                            <i class="fas fa-envelope red-text" fa-lg></i>
                        </td>
                        <td>
                            <mdb-badge pill="true" success="true">Aprobado</mdb-badge>
                        </td>
                        <td>
                            <mdb-badge pill="true" success="true">Aprobado</mdb-badge>
                        </td>
                    </tr>
                    <tr>
                        <td>06/04/2021</td>
                        <td>566013</td>
                        <td>92083000-5</td>
                        <td>DIMACOFI SA</td>
                        <td>124.200</td>
                        <td>0</td>
                        <td>0</td>
                        <td>147.964</td>
                        <td class="text-center">
                            <i class="fa fa-check-circle fa-lg green-text"></i>
                        </td>
                        <td class="text-center"><i class="fas fa-envelope" fa-lg></i></td>
                        <td></td>
                        <td>
                            <mdb-badge pill="true" danger="true">Rechazado</mdb-badge>
                        </td>
                    </tr>
                    <tr>
                        <td>06/04/2021</td>
                        <td>466</td>
                        <td>77025858-8</td>
                        <td>KEZEO SPA</td>
                        <td>690.336</td>
                        <td>0</td>
                        <td>0</td>
                        <td>821.500</td>
                        <td class="text-center">
                            <i class="fa fa-check-circle fa-lg green-text"></i>
                        </td>
                        <td class="text-center"><i class="fas fa-envelope" fa-lg></i></td>
                        <td>
                            <mdb-badge pill="true" success="true">Aprobado</mdb-badge>
                        </td>
                        <td>
                            <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect
                                (click)="showModalObservaciones()">
                                Enviar
                            </button>
                        </td>
                    </tr> -->
                </tbody>
                <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
                    *ngIf="listaDocumentos?.length > 0"></app-pagination>
            </table>
        </div>
    </div>
</div>

<!-- MODAL observacionesModal -->
<app-empresas-recibidos-modal-observaciones relativeId="sii_intercambio"></app-empresas-recibidos-modal-observaciones>

<app-modal-confirm>
</app-modal-confirm>